const PIXEL_ID = '1703383767307378'

let initialized = false

export function initPixel() {
  if (initialized || typeof window === 'undefined') return
  if ((window as any).fbq) {
    initialized = true
    return
  }

  // Inject the exact Facebook Pixel base code via script
  const script = document.createElement('script')
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${PIXEL_ID}');
    fbq('track', 'PageView');
  `
  document.head.appendChild(script)

  // Noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.head.appendChild(noscript)

  initialized = true
}

export function trackAddToCart() {
  const fbq = (window as any).fbq
  if (fbq) {
    fbq('track', 'AddToCart', {
      content_name: 'Devoción sin Culpa',
      content_type: 'product',
      value: 9300,
      currency: 'ARS',
    })
  }
}
